import React from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {paginaDelMenu, promozioni} from '../../moduli/leggi';
import {useSkin} from '../../moduli/useSkin';
import {indirizzoImmagine} from '../../utils/immagini';
import Nota from '../Vetrina/Nota';
import {TestoImpaginato} from '../Vetrina/PaginaTesto';
import './Pagine.css';

/**
 * LA PAGINA PROMOZIONI (modulo Pagine › Promozioni, /promozioni): in cima
 * l'offerta principale (riga, titolo, cifra in oro, pulsante, sfondo), poi
 * le pastiglie dei tipi («Tutte» e un tipo per ogni tipo scritto nelle
 * schede) e le schede delle promozioni, quattro per riga dal computer, due
 * sul tablet, una sul telefono. Tutto lo scrive la skin dal backoffice: la
 * pagina non sa quali bonus il giocatore ha gia' preso, e' una vetrina.
 *
 * Spenta, l'indirizzo porta alla Home. Senza promozioni scritte resta il
 * posto vuoto, con scritto perche' solo in anteprima.
 */
export default function Promozioni() {
  useSkin();
  const {t} = useTranslation();
  const navigate = useNavigate();
  const pagina = paginaDelMenu('promozioni');
  const p = promozioni();
  const [tipo, setTipo] = React.useState('');
  if (!pagina || !pagina.acceso) return <Navigate to={'/'} replace/>;
  const titolo = pagina.titolo === pagina.titoloDiSerie ? t('Promozioni') : pagina.titolo;
  const vai = (dove) => {
    if (!dove) return;
    if (/^https?:\/\//i.test(dove)) window.open(dove, '_blank', 'noopener');
    else navigate(dove);
  };
  const viste = tipo ? p.promo.filter((r) => r.tipo === tipo) : p.promo;
  return (
    <div className={'vetrina pg-promozioni'}>
      {p.apertura && (
        <section className={'pg-apertura'} aria-label={p.apertura.titolo || titolo}
          style={p.apertura.immagine ? {backgroundImage: 'url("' + indirizzoImmagine(p.apertura.immagine) + '")'} : undefined}>
          <div className={'pg-apertura-testi'}>
            {p.apertura.riga && <p className={'pg-apertura-riga'}>{p.apertura.riga}</p>}
            {p.apertura.titolo && <h1>{p.apertura.titolo}</h1>}
            <p className={'pg-apertura-cifra'}>{p.apertura.cifra}</p>
            {p.apertura.pulsante && p.apertura.collegamento && (
              <button type={'button'} className={'pg-oro'} onClick={() => vai(p.apertura.collegamento)}>{p.apertura.pulsante}</button>
            )}
          </div>
        </section>
      )}
      <section className={'pg-corpo'} aria-label={titolo}>
        {!p.apertura && <h1 className={'pg-titolo'}>{titolo}</h1>}
        {p.tipi.length > 1 && (
          <div className={'pg-tipi'} role={'tablist'} aria-label={t('Tipo di promozione')}>
            {[''].concat(p.tipi).map((x) => (
              <button type={'button'} role={'tab'} key={x || 'tutte'} aria-selected={tipo === x}
                className={'pg-tipo' + (tipo === x ? ' scelto' : '')} onClick={() => setTipo(x)}>
                {x || t('Tutte')}
              </button>
            ))}
          </div>
        )}
        {!p.promo.length && (
          <Nota tono={'spento'} giocatore={t('Non ci sono promozioni in questo momento.')}>
            {t('Le promozioni si scrivono dal backoffice (Moduli › Pagine › Promozioni). Oggi non ce n’è ancora nessuna.')}
          </Nota>
        )}
        {viste.length > 0 && (
          <div className={'pg-promo-griglia'}>
            {viste.map((r, i) => (
              <article key={i} className={'pg-promo'}>
                <div className={'pg-promo-immagine' + (r.immagine ? ' con-immagine' : '')}
                  style={r.immagine ? {backgroundImage: 'url("' + indirizzoImmagine(r.immagine) + '")'} : undefined}>
                  {r.tipo && <span className={'pg-promo-tipo'}>{r.tipo}</span>}
                </div>
                <div className={'pg-promo-testi'}>
                  <h2>{r.titolo}</h2>
                  {r.testo && <p>{r.testo}</p>}
                  {r.collegamento && (
                    <button type={'button'} className={'pg-oro pg-promo-pulsante'} onClick={() => vai(r.collegamento)}
                      aria-label={(r.pulsante || t('Scopri')) + ': ' + r.titolo}>{r.pulsante || t('Scopri')}</button>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
        {p.nota && <div className={'pg-nota'}><TestoImpaginato testo={p.nota}/></div>}
      </section>
    </div>
  );
}
